module.exports = __webpack_public_path__ + "img/Musee-de-la-ville.8b072c35.png";